import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Swal from "sweetalert2";
import './style.css'



const Box = styled.div`
  width: 100vw;  

`;

const DivMaster = styled.div`
  height: auto; 
  width: 98%; 
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  margin: 0px;
  gap: 10px;
  background: #f7f7f8; 
  border-radius: 10px; 
  transition: transform 0.1s, background 0.3s;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap; /* Impede quebra de linha */
  overflow-x: auto; /* Habilita scroll horizontal */
  white-space: nowrap; /* Impede que os itens quebrem para a próxima linha */
  border: 1px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  h2 {
    text-align: start;
    color: #3a3f42;
  }
`;
const DivBox = styled.div`

  text-align: center;
  box-sizing: border-box;
  margin: 5px;
  display: flex;
  gap: 10px
`;

const ContainerColuna = styled.div`
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start; /* Alinha à esquerda para crescimento horizontal */
  flex-wrap: nowrap; /* Evita quebra de linha, permite crescimento horizontal */
  padding: 10px; 
  gap: 10px; 
  background-color: transparent;
  width: 100%;
  height: auto;
  overflow-x: auto; /* Habilita rolagem horizontal */
  white-space: nowrap; /* Impede que o conteúdo quebre para a próxima linha */

`;
const Div = styled.div`
  width: 300px; /* Largura fixa para os cartões */
  height: 100%;;
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
  align-items: flex-start; 
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f4f4f5;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1); 
  transition: transform 0.2s, background 0.3s;
  
  &:hover {
    box-shadow: 0 4px 6px gray;
  }

  p {
    color: #3a3f42;
    font-size: 18px;
  }
  
  div{
    text-align: left;
  }
`;

const P = styled.p`
  font-size: 19px;
  color: #3a3f42;
  text-align: left;
  overflow-wrap: break-word; /* Quebra palavras longas */
  white-space: normal; /* Permite que o texto quebre em várias linhas */
  height: 110px;
  overflow: hidden;
`;

const DivCabecario = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; 
  width: 98%;
  margin: 5px;
  display: flex;
  gap: 10px
`;

const Input = styled.input`
  width: 450px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 10px; 
  height: 27px;
  font-size: 20px;
  height: 36px;
  background-color: #f4f4f5;
  color: #3a3f42;
  margin-top: 10px;
`;


const Grid = ({ setVerQuadro, quadroCompartilhados }) => {

  //---------------------------------------------------------------------------------------------------------------//

  const showPopUp2 = (titulo) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Gostaria de visualizar o quadro: "${titulo}" ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };

  const handleEdit = async (quadro) => {
    try {
      const userConfirmed = await showPopUp2(quadro.TITULO_QUADRO); // Passa o título do quadro
      if (!userConfirmed) {
        return; // Se o usuário não confirmar, interrompe a execução
      }


      setVerQuadro(quadro); // Continua se o usuário confirmar
    } catch (error) {
      console.error(error);
    }
  };

  //----------------------------------------CAMPO DE PESQUISA-----------------------------------------------------------------------//

  //states do pesquisar
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [filtroQuadro, setFiltroQuadro] = useState(quadroCompartilhados);

  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = quadroCompartilhados.filter((user) => {
        const columnsToSearch = [
          'TITULO_QUADRO',
          'NOMECRIADOR',

        ];

        // Verifica se algum dos valores nas colunas contém o termo de pesquisa
        return columnsToSearch.some((column) => {
          const columnValue = user[column] ? user[column].toLowerCase() : '';
          return columnValue.includes(term.toLowerCase());
        });
      });
      setFiltroQuadro(filtered);
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    handleSearch(searchTerm);

  }, [searchTerm, quadroCompartilhados]);

  //---------------------------------------------------------------------------------------------------------------//


  return (
    <div>

      <ContainerColuna>
        <Box >

          <DivMaster className='scroll'>

            <DivCabecario>
              <h2>Quadros que foram compartilhados com você:</h2>
              <Input
                type="text"
                placeholder="Pesquisar quadro, nome..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </DivCabecario>

            <DivBox>
              {filtroQuadro
                .map((quadro) => {
                  return (
                    <Div key={quadro.ID_QUADRO} onClick={() => handleEdit(quadro)} type="button">
                      <P>{quadro.TITULO_QUADRO}</P>

                      <div>
                        <p>{quadro.NOMECRIADOR}</p>
                      </div>
                    </Div>
                  );
                })
              }
            </DivBox>


          </DivMaster>



        </Box>

      </ContainerColuna>

    </div>

  );
};

export default Grid;
